import { Popover } from '@headlessui/react';
import { useState } from 'react';
import { KoobEmptyState } from '@koob/ui';
import { useTranslation } from 'react-i18next';
import NotificationPopoverListItem from './NotificationPopoverListItem';
import NotificationPopoverLoading from './NotificationPopoverLoading';
import NotificationPopoverTriggerLabel from './NotificationPopoverTriggerLabel';
import NotificationPopoverActionBar from './NotificationPopoverActionBar';

export default function NotificationPopover({
  notifications,
  loading,
  reload,
  markAsRead,
  markAllAsRead,
  navigate,
  scope,
}) {
  const { t } = useTranslation('notifications');
  const [unreadOnly, setUnreadOnly] = useState(true);

  const unreadNotificationsCount = notifications?.filter(
    (n) => !n.readAt,
  )?.length;

  const filteredNotifications = unreadOnly
    ? notifications?.filter((n) => !n.readAt)
    : notifications;

  // No polling here: this interval was never cleared, so every remount of the
  // popover (every navigation on the TO, where it lives in the layout) stacked
  // another one. Refreshes now come from the SSE push in NotificationsProvider.

  return (
    <Popover className="relative transition">
      <Popover.Button className="border-none focus:outline-none">
        <div className="relative">
          <i className="far fa-bell text-2xl text-gray-400 hover:text-gray-500 transition" />

          {unreadNotificationsCount > 0 && (
            <NotificationPopoverTriggerLabel>
              {unreadNotificationsCount > 99 ? '99+' : unreadNotificationsCount}
            </NotificationPopoverTriggerLabel>
          )}
        </div>
      </Popover.Button>

      <Popover.Panel className="fixed right-5 top-20 z-popover">
        <div className="bg-white/80 backdrop-blur-md w-[500px] rounded-lg shadow-k p-4">
          <NotificationPopoverActionBar
            unreadNotificationsCount={unreadNotificationsCount}
            unreadOnly={unreadOnly}
            setUnreadOnly={setUnreadOnly}
            markAllAsRead={markAllAsRead}
            navigate={navigate}
            reload={reload}
            loading={loading}
          />

          {!loading || notifications?.length > 0 ? (
            <>
              {filteredNotifications?.length > 0 ? (
                <div className="h-72 overflow-y-scroll">
                  {filteredNotifications?.map((notification) => (
                    <NotificationPopoverListItem
                      key={notification.id}
                      notification={notification}
                      markAsRead={markAsRead}
                      navigate={navigate}
                      scope={scope}
                    />
                  ))}
                </div>
              ) : (
                <div className="h-56 flex items-center">
                  <KoobEmptyState
                    variant="plain"
                    icon={<i className="far fa-sparkles text-2xl" />}
                    title={t('emptyState.title')}
                    description={t('emptyState.description')}
                  />
                </div>
              )}
            </>
          ) : (
            <NotificationPopoverLoading />
          )}
        </div>
      </Popover.Panel>
    </Popover>
  );
}
